import {
 
  FETCH_ORDER_REQUEST,
  FETCH_ORDER_SUCCESS,
  FETCH_ORDER_FAILURE,

  CREATE_ORDER_REQUEST,
  CREATE_ORDER_SUCCESS,
  CREATE_ORDER_FAILURE,

  UPDATE_ORDER_REQUEST,
  UPDATE_ORDER_SUCCESS,
  UPDATE_ORDER_FAILURE,

  DELETE_ORDER_REQUEST,
  DELETE_ORDER_SUCCESS,
  DELETE_ORDER_FAILURE,
} from "./orderActionTypes";

export const fetchOrderRequest = () => ({
  type: FETCH_ORDER_REQUEST,
});

export const fetchOrderSuccess = (data, dataType) => ({
  type: FETCH_ORDER_SUCCESS,
  payload: { data, type: dataType },
});

export const fetchOrderFailure = (error) => ({
  type: FETCH_ORDER_FAILURE,
  payload: error,
});

export const createOrderRequest = () => ({
  type: CREATE_ORDER_REQUEST,
});

export const createOrderSuccess = (data, dataType) => ({
  type: CREATE_ORDER_SUCCESS,
  payload: { data, type: dataType },
});

export const createOrderFailure = (error) => ({
  type: CREATE_ORDER_FAILURE,
  payload: error,
});

export const updateOrderRequest = () => ({
  type: UPDATE_ORDER_REQUEST,
});

export const updateOrderSuccess = (data, dataType) => ({
  type: UPDATE_ORDER_SUCCESS,
  payload: { data, type: dataType },
});

export const updateOrderFailure = (error) => ({
  type: UPDATE_ORDER_FAILURE,
  payload: error,
});

export const deleteOrderRequest = () => ({
  type: DELETE_ORDER_REQUEST,
});

export const deleteOrderSuccess = (data, dataType) => ({
  type: DELETE_ORDER_SUCCESS,
  payload: { data, type: dataType },
});

export const deleteOrderFailure = (error) => ({
  type: DELETE_ORDER_FAILURE,
  payload: error,
});
